import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {ProviderModel} from './ProviderModel';
import {ServiceVariantModel} from './ServiceVariantModel';

export class ConsuntivoChargesModel {
  id: number;
  numAnnoMese: number;
  numAnnoMeseRif: number;
  srv: string;
  region: RegionModel;
  servicesCountry: string;
  billingCountry: string;
  localCustomer: LocalCustomerModel;
  contractType: ContractTypeModel;
  resourceUnit: ResourcesUnitModel;
  serviceVariant: ServiceVariantModel;
  provider: ProviderModel;
  isRecovery: boolean;
  charge: number;
  numAnnoMeseAcceptance: number;
  residualMonth: number;
  percUse: number;
  notes: string;
  workflowStatus: string;
  workflowClosed: boolean;

  actualQuantityFilter: number;
  docType: string;

  constructor(id?: number,
              numAnnoMese?: number,
              numAnnoMeseRif?: number,
              srv?: string,
              region?: RegionModel,
              servicesCountry?: string,
              billingCountry?: string,
              localCustomer?: LocalCustomerModel,
              resourceUnit?: ResourcesUnitModel,
              contractType?: ContractTypeModel,
              serviceVariant?: ServiceVariantModel,
              provider?: ProviderModel,
              isRecovery?: boolean,
              charge?: number,
              numAnnoMeseAcceptance?: number,
              residualMonth?: number,
              percUse?: number,
              notes?: string) {
    this.id = id;
    this.numAnnoMese = numAnnoMese;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.srv = srv;
    this.region = region;
    this.servicesCountry = servicesCountry;
    this.billingCountry = billingCountry;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.contractType = contractType;
    this.serviceVariant = serviceVariant;
    this.provider = provider;
    this.isRecovery = isRecovery;
    this.charge = charge;
    this.numAnnoMeseAcceptance = numAnnoMeseAcceptance;
    this.residualMonth = residualMonth;
    this.percUse = percUse;
    this.notes = notes;
  }
}

export class ConstuntivoChargesStorargeModel extends ConsuntivoChargesModel {
  actualQuantityFilter: number = null;
}

export class ConsuntivoChargesReportModel extends  ConsuntivoChargesModel {
  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;
}
export class ConsuntivoChargesByRefMonthModel extends  ConsuntivoChargesModel {
  numAnnoMeseRifFrom: number;
  numAnnoMeseRifTo: number;
}
